

import {
  Dashboard as DashboardIcon,
  Business as BusinessIcon,
  Folder as FolderIcon,
  People as PeopleIcon,
  Router as RouterIcon,
  Build as BuildIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon,
  VpnKey as VpnKeyIcon,
  ModelTraining as ModelIcon,
  Straighten as StraightenIcon,
  Schedule as ScheduleIcon,
  Api as ApiIcon,
} from '@mui/icons-material';


const menuItems = [
  {
    text: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/',
  },
  {
    text: 'Models',
    icon: <ModelIcon />,
    path: '/models',
  },
  // {
  //   text: 'Projects',
  //   icon: <FolderIcon />,
  //   path: '/projects',
  // },
  {
    text: 'Companies',
    icon: <BusinessIcon />,
    path: '/companies',
  },
  // {
  //   text: 'Users',
  //   icon: <PeopleIcon />,
  //   path: '/users',
  // },
  {
    text: 'IoT Devices',
    icon: <RouterIcon />,
    path: '/iot-devices',
  },
    {
    text: 'Sensor Data',
    icon: <RouterIcon />,
    path: '/sensor-data',
  },
  {
    text: 'External APIs',
    icon: <ApiIcon />,
    path: '/external-apis',
  },
  // {
  //   text: 'Equipment',
  //   icon: <BuildIcon />,
  //   path: '/equipment',
  // },
  // {
  //   text: 'Equipment Specs',
  //   icon: <SettingsIcon />,
  //   path: '/equipment-specs',
  // },
  // {
  //   text: 'Alerts',
  //   icon: <NotificationsIcon />,
  //   path: '/alerts',
  // },
  // {
  //   text: 'API Keys',
  //   icon: <VpnKeyIcon />,
  //   path: '/api-keys',
  // },

  // {
  //   text: 'Units',
  //   icon: <StraightenIcon />,
  //   path: '/units',
  // },
  {
    text: 'Scheduled Jobs',
    icon: <ScheduleIcon />,
    path: '/scheduled-jobs',
  }
];

export default menuItems;
